import { useCallback } from "react"
import { getDraftOrPublishedSchedule } from "authoring/routes/project/controller/get-draft-or-published-schedule"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { saveScheduleDraft } from "../controller/save-schedule-draft"

export function useDraftSchedule({ projectId, scheduleId } = {}) {
    const data = getDraftOrPublishedSchedule.useResultsOnce(
        {
            projectId,
            scheduleId,
        },
        { fetchPolicy: "no-cache" },
        withInitialValue(IS_LOADING)
    )
    const loading = data === IS_LOADING
    const draft = loading ? null : data ?? null

    const saveDraft = useCallback(
        (draft) => {
            if (!projectId || !scheduleId || !draft) return null
            return saveScheduleDraft({ projectId, scheduleId, draft })
        },
        [projectId, scheduleId]
    )

    return {
        draft,
        isDraft: draft?.isDraft ?? false,
        status: draft?.status ?? null,
        reviewCycle: draft?.reviewCycle ?? null,
        loading,
        saveDraft,
    }
}
